import API from 'js/lib/api';

export default API('/api', {
  type: 'rest',
});
